import {Injectable} from "@angular/core";

@Injectable()
export class PaiementStore {

  private paiementKey: string;

  constructor() {
  }


  setPaiementKey(paiementKey: string) {
    this.paiementKey = paiementKey;
  }

  getPaiementKey(): string {
    return this.paiementKey;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/pages/cerba/pages/paiement.store.ts